import { createFileRoute } from "@tanstack/react-router"

import { GuildWarSignupPage } from "@/components/guild-war/guild-war-signup-page"

export const Route = createFileRoute("/_authed/guild-war-signup")({
  component: GuildWarSignupRoute,
})

function GuildWarSignupRoute() {
  const { auth } = Route.useRouteContext()

  if (!auth.user) {
    return null
  }

  return <GuildWarSignupPage userId={auth.user.userId} />
}
